import _ from 'underscore';
import SiteModal from './site-modal';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const modalTemplate =
  `<div class="modal {{ id }}" id="{{ id }}" tabindex="0" aria-label="Play video in overlay">
      <div class="modal-overlay" style="pointer-events: none;"></div>
      <div class="modal-panel" role="dialog" aria-modal="true"  aria-label="video model">
        <button type="button"  class="close-btn" aria-label="Close Modal" style="margin-top:70px;"><p style="position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0, 0, 0, 0); border: 0;">X</p></button>
        <div class="modal-inner">
          <div class="modal-content">
            <div style="background:#000;position:relative;width:100%;height:0;padding-bottom:56.25%;">
              <iframe src="{{ url }}"  title="{{ iframetitle }}" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>`;
const modalTemplateVals = _.template(modalTemplate);

const videoModal = () => {
  const initModal = (btn) => {
    // debugger;
    const id = btn.getAttribute('data-modal-id');
    const iframetitle = btn.getAttribute('data-title');
    const url = btn.getAttribute('data-video-url');
    const body = document.querySelector('body');
    const div = document.createElement('div');
    const compiled = modalTemplateVals({
      id,
      url,
      iframetitle,
    });
    div.innerHTML = compiled;
    body.appendChild(div.firstChild);
    const modal = new SiteModal({
      id,
      callbacks: {
        onClose: () => {
          const modalDiv = document.getElementById(id);
          if (modalDiv !== null) {
            modalDiv.remove();
          }
        },
      },
    });
    modal.open();
  };

  const onDocumentClick = (event) => {
    const { target } = event;
    let btn = target.closest('.button-video');
    // If null, also check if target contains
    // data-modal-id and data-video-url attributes
    if (btn === null) {
      const isModalId = target.getAttribute('data-modal-id') !== null;
      const isVideoUrl = target.getAttribute('data-video-url') !== null;
      if (isModalId && isVideoUrl) {
        btn = target;
      }
    }
    if (btn !== null) {
      event.preventDefault();
      initModal(btn);
    }
  };

  document.addEventListener('click', onDocumentClick);
};

export default videoModal;
